import { useContext, useCallback, useMemo } from 'react';
import { AppContext } from '../app-context.js';
import { UserType, USER_GROUP } from '../constants/authorizedUsers.js';
import '../constants/bidStatus.js';
import '../constants/bulkLoadCardStatus.js';
import '../constants/misc.js';
import '../constants/event-names.js';
import '../constants/eventsMapObj.js';
import '../constants/Faq.js';
import '../constants/languages.js';
import '../constants/loadStatus.js';
import '../constants/lorryStatus.js';
import '../constants/lorryTypes.js';
import '../constants/mostSearchedLinks.js';
import '../constants/Pages.js';
import 'bowser';
import '../_virtual/_tslib.js';
import '../components/toast/toast.js';
import '../_services/auth.service.js';
import '../methods/getAuthIdParam.js';
import 'react-cookie';
import '../methods/formatDate.js';
import '../constants/StateList.js';
import '../methods/getTransporterFigure.js';
import '../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../constants/serviceTypeId.js';
import '../constants/bidUpdateType.js';
import '../constants/userAction.js';
import '../constants/api.js';
import '../constants/link.js';
import '../constants/market.js';
import '../constants/payment.js';
import '../constants/admin/screenId.js';
import '../_services/const.js';

const useCsDashboard = () => {
    const { csDashboardPermission, csDashboardUserRoles, isCsDashboardUser, companyId } = useContext(AppContext);
    const checkRole = useCallback((role) => {
        return (isCsDashboardUser &&
            Array.isArray(role) &&
            !!(role === null || role === void 0 ? void 0 : role.length) &&
            (role === null || role === void 0 ? void 0 : role.some((r) => csDashboardUserRoles === null || csDashboardUserRoles === void 0 ? void 0 : csDashboardUserRoles.includes(r))));
    }, [csDashboardUserRoles]);
    const checkPermission = useCallback((operation, filterType = "or") => {
        var _a;
        if (!isCsDashboardUser) {
            return false;
        }
        if (Array.isArray(operation)) {
            if (filterType === "and") {
                return operation.every((op) => csDashboardPermission === null || csDashboardPermission === void 0 ? void 0 : csDashboardPermission.includes(op));
            }
            else {
                return operation.length > 0 ? operation.some((op) => csDashboardPermission === null || csDashboardPermission === void 0 ? void 0 : csDashboardPermission.includes(op)) : true;
            }
        }
        else {
            return operation ? !!((_a = csDashboardPermission === null || csDashboardPermission === void 0 ? void 0 : csDashboardPermission.includes) === null || _a === void 0 ? void 0 : _a.call(csDashboardPermission, operation)) : false;
        }
    }, [csDashboardPermission]);
    const derivedRole = useMemo(() => {
        return {
            isTso: checkRole([UserType.TSO]) && checkPermission("tagAgent"),
            isTsoV2: checkRole(USER_GROUP.TSO_V2),
            isInternalUser: !!checkRole(USER_GROUP.INTERNAL_USERS),
            isSuperUser: !!checkRole(USER_GROUP.SUPER_USERS),
            isSuperAdmin: !!checkRole([UserType.SUPER_ADMIN]),
            isDeveloper: !!checkRole([UserType.DEVELOPER]),
            isAdmin: !!checkRole(USER_GROUP.ADMINS)
        };
    }, [csDashboardPermission, csDashboardUserRoles]);
    return Object.assign({ checkPermission: checkPermission, isCsDashboardUser: !!isCsDashboardUser, currentOperation: undefined, currentRole: undefined, checkRole: checkRole }, (isCsDashboardUser && Object.assign(Object.assign({}, derivedRole), { currentOperation: csDashboardPermission, currentRole: csDashboardUserRoles, csUserCompanyId: Number(companyId) })));
};

export { useCsDashboard };
//# sourceMappingURL=useCsDashboard.js.map
